import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { InputPrice } from '../input';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useSendOfferMarketplaceMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

export const marketplaceSendOfferModal: any = {};

export const MarketplaceSendOfferModal = () => {
  const { mutate } = useSendOfferMarketplaceMutation();
  const [open, setOpen] = useState(false);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    marketplaceSendOfferModal.open = () => {
      marketplaceSendOfferModal.action = 'Send Offer';
      marketplaceSendOfferModal.name = `${marketplaceSendOfferModal.action} ${marketplaceSendOfferModal.number}`;

      marketplaceSendOfferModal.isSubmitClicked = false;
      setPrice(marketplaceSendOfferModal.price);
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(marketplaceSendOfferModal).forEach((key) => {
      if (key !== 'open') delete marketplaceSendOfferModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      { id: marketplaceSendOfferModal.id, price: Number(price) },
      {
        onSuccess: () => {
          setOpen(false);
          marketplaceSendOfferModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.MARKETPLACE.ERROR.NOT_SEND_OFFER, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'marketplace-send-offer-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {marketplaceSendOfferModal.name}
        </Typography>
        <InputPrice
          label={i18n.t('label.price')}
          data-size={'medium'}
          defaultValue={price}
          onChange={(e) => setPrice(Number(e.target.value))}
        />
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            Send Offer
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
